var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "envelope") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 12.996A5 5 0 0 1 7.007 8h33.986C43.755 8 46 10.242 46 12.996v22.008A5 5 0 0 1 40.993 40H7.007C4.245 40 2 37.758 2 35.004V12.996zm40 7.535L25.03 30.715a2 2 0 0 1-2.06 0L6 20.53v14.473c0 .543.453.996 1.007.996h33.986A1 1 0 0 0 42 35.004V20.53zm-1.603-3.703c.823-.494 1.603-1.87 1.603-2.821v-1.01a.997.997 0 0 0-.994-.997H6.994a.997.997 0 0 0-.994.997v1.01c0 .946.785 2.33 1.603 2.82L24 26.668l16.397-9.84z",
    fillRule: "nonzero",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.efde4f3a981a41250f0aaa9d2d40ceaf.svg";
export { ForwardRef as ReactComponent };